import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "projects",
  class: "projects"
}
const _hoisted_2 = {
  ref: "listEl",
  class: "projects__container reveal-on-scroll"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JroProjectNew = _resolveComponent("JroProjectNew")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("Home.privateProjects")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_JroProjectNew, {
        year: "2026",
        inProgress: true,
        title: _ctx.$t('Projects.bautb.title'),
        image: "images/bautb.jpeg",
        subtitle: _ctx.$t('Projects.bautb.subtitle'),
        action: _ctx.$t('Projects.bautb.action'),
        link: _ctx.$t('Projects.bautb.link')
      }, null, 8, ["title", "subtitle", "action", "link"]),
      _createVNode(_component_JroProjectNew, {
        year: "2024",
        title: _ctx.$t('Projects.wingspan.title'),
        image: "images/wingspan.jpeg",
        subtitle: _ctx.$t('Projects.wingspan.subtitle'),
        action: _ctx.$t('Projects.wingspan.action'),
        link: _ctx.$t('Projects.wingspan.link')
      }, null, 8, ["title", "subtitle", "action", "link"]),
      _createVNode(_component_JroProjectNew, {
        year: "2023",
        title: _ctx.$t('Projects.vrgames.title'),
        image: "images/vrgame.jpeg",
        subtitle: _ctx.$t('Projects.vrgames.subtitle'),
        action: _ctx.$t('Projects.vrgames.action'),
        link: _ctx.$t('Projects.vrgames.link')
      }, null, 8, ["title", "subtitle", "action", "link"]),
      _createVNode(_component_JroProjectNew, {
        year: "2023",
        inProgress: true,
        title: _ctx.$t('Projects.homeautomation.title'),
        image: "images/homeautomation.jpeg",
        subtitle: _ctx.$t('Projects.homeautomation.subtitle')
      }, null, 8, ["title", "subtitle"]),
      _createVNode(_component_JroProjectNew, {
        year: "2022",
        title: _ctx.$t('Projects.mediaOrga.title'),
        image: "images/mediaOrga.jpg",
        subtitle: _ctx.$t('Projects.mediaOrga.subtitle'),
        action: _ctx.$t('Projects.mediaOrga.action'),
        link: _ctx.$t('Projects.mediaOrga.link')
      }, null, 8, ["title", "subtitle", "action", "link"]),
      _createVNode(_component_JroProjectNew, {
        year: "2019",
        title: _ctx.$t('Projects.hhb.title'),
        subtitle: _ctx.$t('Projects.hhb.subtitle'),
        action: _ctx.$t('Projects.hhb.action'),
        link: _ctx.$t('Projects.hhb.link')
      }, null, 8, ["title", "subtitle", "action", "link"]),
      _createVNode(_component_JroProjectNew, {
        year: "2019",
        title: _ctx.$t('Projects.logger.title'),
        subtitle: _ctx.$t('Projects.logger.subtitle'),
        action: _ctx.$t('Projects.logger.action'),
        link: _ctx.$t('Projects.logger.link')
      }, null, 8, ["title", "subtitle", "action", "link"]),
      _createVNode(_component_JroProjectNew, {
        year: "2018",
        title: _ctx.$t('Projects.leanCanvas.title'),
        image: "images/leanCanvas.jpg",
        subtitle: _ctx.$t('Projects.leanCanvas.subtitle'),
        action: _ctx.$t('Projects.leanCanvas.action'),
        link: _ctx.$t('Projects.leanCanvas.link')
      }, null, 8, ["title", "subtitle", "action", "link"]),
      _createVNode(_component_JroProjectNew, {
        year: "2017",
        title: _ctx.$t('Projects.visualObserver.title'),
        image: "images/observer.jpg",
        subtitle: _ctx.$t('Projects.visualObserver.subtitle'),
        action: _ctx.$t('Projects.visualObserver.action'),
        link: _ctx.$t('Projects.visualObserver.link')
      }, null, 8, ["title", "subtitle", "action", "link"]),
      _createVNode(_component_JroProjectNew, {
        year: "2014",
        title: _ctx.$t('Projects.headphones.title'),
        image: "images/master.jpg",
        subtitle: _ctx.$t('Projects.headphones.subtitle'),
        action: _ctx.$t('Projects.headphones.action'),
        link: _ctx.$t('Projects.headphones.link')
      }, null, 8, ["title", "subtitle", "action", "link"]),
      _createVNode(_component_JroProjectNew, {
        year: "2013",
        title: _ctx.$t('Projects.weatherStation.title'),
        subtitle: _ctx.$t('Projects.weatherStation.subtitle'),
        action: _ctx.$t('Projects.weatherStation.action'),
        link: _ctx.$t('Projects.weatherStation.link')
      }, null, 8, ["title", "subtitle", "action", "link"])
    ], 512)
  ]))
}